import {
  AtTabs,
  AtTag,
  AtTagFolioStatus,
  AtTagNumberVariant,
  AtTagType,
  MlToast,
  MlToastVariant,
} from "@csc-dashboard/components-library";

const TOAST_MESSAGE =
  "Mientras la atención esté en curso, el folio permanecerá activo.";

const TABS = [
  { label: "Cliente", value: "client" },
  { label: "Folios", value: "folios" },
  { label: "Notas", value: "notes" },
];

type TabValue = "client" | "folios" | "notes" | "notes-form" | "folio-detail";

interface TopContentProps {
  selectedTab: TabValue;
  hideAlert: boolean;
  folio: string;
  folioStatus: AtTagFolioStatus;
  handleTabChange: (tab: TabValue) => void;
  removeAlert: () => void;
}

export const TopContent = ({
  selectedTab,
  hideAlert,
  handleTabChange,
  removeAlert,
  folio,
  folioStatus,
}: TopContentProps) => {
  return (
    <div className="flex flex-col ">
      <div className="flex flex-col gap-4">
        {!hideAlert && (
          <MlToast
            title={TOAST_MESSAGE}
            variant={MlToastVariant.INFO}
            onClose={removeAlert}
          />
        )}
        <p className="font-semibold text-surface-500">Atención en curso</p>

        <div className="flex gap-2 items-center">
          <p className="text-normal text-surface-500">Folio</p>
          <AtTag
            type={AtTagType.NUMBER}
            label={folio}
            variant={AtTagNumberVariant.FOLIO}
          />
          <AtTag type={AtTagType.FOLIO} status={folioStatus} />
        </div>
      </div>

      <hr className="border-surface-75 border-t-1 mt-4" />

      <AtTabs
        activeTab={selectedTab}
        onTabChange={(value) => handleTabChange(value as TabValue)}
        tabs={TABS}
        variant="mini"
        className="mb-4"
      />
    </div>
  );
};
